import React from 'react';

/** AI 자료 입력 사진 칸 아이콘 — 단색(#10504a) 기하 도형, 비활성 칸에서는 currentColor로 회색 */
const base = { width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const, 'aria-hidden': true };

export const CameraIcon: React.FC = () => (
  <svg {...base}>
    <path d="M4 8h3l2-3h6l2 3h3v11H4z" />
    <circle cx="12" cy="13" r="3.5" />
  </svg>
);

export const ClipboardIcon: React.FC = () => (
  <svg {...base}>
    <rect x="5" y="4" width="14" height="17" rx="2" />
    <rect x="9" y="2.5" width="6" height="3.5" rx="1" />
    <path d="M9 12h6M9 16h4" />
  </svg>
);

export const UploadIcon: React.FC = () => (
  <svg {...base}>
    <path d="M12 16V5M7.5 9.5 12 5l4.5 4.5" />
    <path d="M4 15v4h16v-4" />
  </svg>
);

/** 메인 프레젠 네비바 웹캠 버튼과 같은 카메라 */
export const NavCameraIcon: React.FC = () => (
  <svg {...base}>
    <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
    <circle cx="12" cy="13" r="3" />
  </svg>
);
